import React from "react";
import ReactDOM from "react-dom";
import { PropTypes } from "prop-types";
import { InfiniteStoryBase, SocialShare, WithHostUrl, Link, WithLazy } from "@quintype/components";
import { get } from "lodash";
import { connect } from "react-redux";
import StoryHeader from "./story-templates/shared/story-header";
import TextStoryHeader from "./story-templates/shared/text-story-header";
import UtStdFirst from "../../atoms/ut-std-first";
import UtStdLast from "../../atoms/ut-std-last";
import StoryPremiumCard from "../../atoms/story-premium-card";
import { STORY_TEMPLATES } from "../../../constants";
import { TextStory } from "./story-templates/text-story-page";
import { AppStory } from "./story-templates/app-story-page";
import { PhotoAlbumStory } from "./story-templates/photo-album-story";
import { VideoStory } from "./story-templates/video";
import { PhotoStory } from "./story-templates/photo";
import { ListicleStory } from "./story-templates/listicle-story";
import { LongFormStory } from "./story-templates/long-form";
import { ReviewStory } from "./story-templates/review";
import { LiveBlogStory } from "./story-templates/live-blog";
import { Explainer } from "./story-templates/explainer";
import { SocialShareTemplate } from "./story-templates/shared/social-share";
import { CartoonStory } from "./story-templates/cartoon";
import Tags from "./story-templates/shared/tags";
import AuthorDetail from "./story-templates/shared/author-detail";
import VuukleCommentCount from "./story-templates/shared/vuukle/count";
import {
  fetchSectionStories,
  fetchLatestStories,
  reqSwgUser,
  fetchLatestAtVikatan,
  fetchTrendingStories,
  fetchCollection,
  fetchEvRecommendation,
  fetchStoryAttributes,
  fetchRfmScore
} from "../../../api";
import { hasStoryAccess, incrementPremiumStoriesRead } from "../../../paywall";
import { GA, DeepBI, currentStory, EVOLOK, STORY_TRACKING } from "../../../integrations";
import { isPremium } from "../../../data/story";
import SecondaryMenu from "../../atoms/secondary-menu";
import { Icon } from "../../atoms/icon";
import Cookies from "universal-cookie";
import styles from "./styles.m.css";
import { isGaa, removeBulletImagesFromStory } from "../../utils/utils";
import StorySecondaryCard from "./story-templates/shared/story-secondary-card";
import { MeteringDemo } from "./swg/metering";
import RegisterDataWall from "../../atoms/register-data-wall";
import { TrendingAMP } from "../../../../isomorphic/components/shared/icons/Trending-amp";
import { LatestAMP } from "../../../../isomorphic/components/shared/icons/Latest-amp";
import { AppInstallAmp } from "../../../../isomorphic/components/shared/icons/AppInstall-amp";
import { MagazineAmp } from "../../../../isomorphic/components/shared/icons/magazine-amp";
import CustomAdslot from "../../atoms/dfp-ad-custom";
const cookies = new Cookies();

function getStoryTemplateComponent(storyTemplate) {
  switch (storyTemplate) {
    case STORY_TEMPLATES.VIDEO:
      return VideoStory;
    case STORY_TEMPLATES.PHOTO:
      return PhotoStory;
    case STORY_TEMPLATES.PHOTO_ALBUM:
      return PhotoAlbumStory;
    case STORY_TEMPLATES.REVIEW:
      return ReviewStory;
    case STORY_TEMPLATES.LISTICLE:
      return ListicleStory;
    case STORY_TEMPLATES.LIVE_BLOG:
      return LiveBlogStory;
    case STORY_TEMPLATES.LONG_FORM:
      return LongFormStory;
    case STORY_TEMPLATES.EXPLAINER:
      return Explainer;
    case STORY_TEMPLATES.APP_STORY:
      return AppStory;
    case STORY_TEMPLATES.CARTOON:
      return CartoonStory;
    default:
      return TextStory;
  }
}

function storyPageFetchRelatedItems(currentHostUrl, story, cinemaMode) {
  return fetchSectionStories(story).then(stories =>
    stories.filter(story => (cinemaMode ? story.url.startsWith(currentHostUrl) : true))
  );
}

function appendCustomQueryStringUrl(story, view = "normal") {
  let newObj = {};
  newObj = story;
  newObj.slug = "glance/" + story.slug;
  return newObj;
}

class StoryTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      relatedStories: [],
      visualStories: null,
      trendingStories: [],
      access: null,
      socialView: false,
      width: global.innerWidth,
      showModal: !!cookies.get("userPaid"),
      activePaywall: this.props.activePaywall,
      activeStdPaywall: this.props.activeStdPaywall,
      jshow: false,
      userType: "F",
      show_rfm: false,
      RFM_SEGMENT: false,
      Glance_utm: ""
    };
    this.floatingbar = React.createRef();
    this.handleClickView = this.handleClickView.bind(this);
  }

  componentDidMount() {
    const { index } = this.props;
    if (typeof this.props.fetchSectionStories === "function") {
      this.props
        .fetchSectionStories(this.props.story)
        .then(relatedStories => {
          this.setState({ relatedStories });
        })
        .catch(console.error);
    }

    global.userPromise.catch(() => null).then(user => {
      if (!user) {
        fetchRfmScore(user, cookies.get("vikatanthinmint"))
          .then(response => {
            this.setState({
              RFM_SEGMENT: get(response, ["user_info", "cookie_user_rfm", "segment"])
            });
          })
          .catch(console.error);
      }
    });
    const storyId = get(this.props.story, ["id"], null);

    fetchTrendingStories(0, 10, { "exclude-story-ids": storyId })
      .then(response => {
        this.setState({ trendingStories: response && response.items });
      })
      .catch(console.error);

    global.userPromise.catch(() => null).then(user => {
      user && this.setState({ userType: user.userType });
    });

    if (index === 0 && isPremium(this.props.story)) {
      hasStoryAccess(this.props.story)
        .then(access => {
          currentStory.storyCookie(this.props.story, "");
          if (access.granted && access.grantReason === "METERING") {
            incrementPremiumStoriesRead(this.props.story.id);
            setTimeout(() => {
              hasStoryAccess(this.props.story).then(access => {
                this.setState({ access: access });
              });
            }, 2000);
          }
          this.setState({ access: access });
        })
        .catch(console.error);
    }

    if (index === 0) {
      this.setState({
        show_rfm: !this.state.show_rfm
      });
      const fetchInitializerListenerId = setInterval(() => {
        if (cookies.get("ev_sid")) {
          this.handleEvFetch();
          clearInterval(fetchInitializerListenerId);
        }
        //
      });
    } else {
      this.handleEvFetch();
    }
    let SET_GLANCE_UTM = window.location && window.location && window.location.search;
    this.setState({
      Glance_utm: SET_GLANCE_UTM
    });
  }

  handleEvFetch = () => {
    fetchEvRecommendation(cookies.get("ev_sid"))
      .then(data => {
        const evData = get(data, ["recommendations"], []);
        this.setState({ evList: evData });
      })
      .catch(console.error);
  };

  componentWillReceiveProps(nextState) {
    if (this.state.activeStdPaywall !== nextState.activeStdPaywall) {
      this.setState({ activeStdPaywall: false });
    }
  }

  handleExpandStory = () => {
    this.setState({
      show_rfm: !this.state.show_rfm
    });
    this.props.firePageView(this.props.story, true);
    global.app.maybeSetUrl(
      "/" + this.props.story.slug + this.state.Glance_utm,
      get(this.props, ["story", "seo", "meta-title"], this.props.story.headline)
    );
    this.props.checkInfoStatus({ id: this.props.story.id, status: true });
    if (isPremium(this.props.story)) {
      hasStoryAccess(this.props.story)
        .then(access => {
          currentStory.storyCookie(this.props.story, "");
          if (access.granted && access.grantReason === "METERING") {
            incrementPremiumStoriesRead(this.props.story.id);
            setTimeout(() => {
              hasStoryAccess(this.props.story).then(access => {
                this.setState({ access: access });
              });
            }, 2000);
          }
          this.setState({ access: access });
        })
        .catch(console.error);
    }
  };

  handleClickView() {
    window.scrollTo({
      top: this.floatingbar.current.offsetTop - 120,
      behavior: "smooth"
    });
  }

  handleClickEvents(args) {
    GA.customEvent(args, this.props.story.id);
    DeepBI.customEvent(args, this.props.story.id);
  }

  CloseStdPaywall(args) {
    this.props.actionhandleStdActivePaywall(false);
  }

  handleCloseDatawall() {
    this.setState({
      show_rfm: !this.state.show_rfm
    });
  }
  render() {
    const story = removeBulletImagesFromStory(get(this.props, ["story"], null));
    if (!story) {
      return null;
    }
    const config = get(this.props, ["config"]);
    const episodes = get(this.props, ["episodes"]);
    const versionStat = get(story, ["pfrom"], null);

    const renderSocialMedia = (className = "") => (
      <SocialShare
        className={className}
        template={SocialShareTemplate}
        fullUrl={story.url}
        title={story.headline}
        handleClickView={this.handleClickView}
        hashtags={
          story.tags &&
          story.tags
            .filter(tag => tag !== null)
            .map(tag => tag.name)
            .toString()
        }
        story={story}
      />
    );

    const renderHeaderCard = ({ className, readMore } = { className: "", readMore: true }) => (
      <StoryHeader
        // renderSocialMedia={renderSocialMedia}
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
        readMore={readMore}
      />
    );

    const renderTextStoryHeaderCard = ({ className, readMore } = { className: "", readMore: true }) => (
      <TextStoryHeader
        // renderSocialMedia={renderSocialMedia}
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
        readMore={readMore}
      />
    );

    const renderSecondaryCard = ({ className } = { className: "" }) => (
      <StorySecondaryCard
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
      />
    );

    const renderTags = () => <Tags tags={story.tags} className={styles.tags} />;

    const renderAuthorDetails = () => (
      <AuthorDetail
        authors={story.authors}
        config={config}
        contributors={story.contributors}
        className={styles["author-detail"]}
      />
    );

    const renderFooter = (isOpen = false) => {
      return (
        <div className="js-story-footer">
          {!isPremium(this.props.story) &&
          this.state.show_rfm &&
          this.props.story["story-template"] === "text" &&
          (this.state.RFM_SEGMENT === "Active1" ||
            this.state.RFM_SEGMENT === "Potential1" ||
            this.state.RFM_SEGMENT === "Loyalists1") ? (
            <RegisterDataWall
              handleCloseDatawall={this.handleCloseDatawall.bind(this)}
              story={get(this.props, ["story"], null)}
              segment={this.state.RFM_SEGMENT}
            />
          ) : null}
          {!isPremium(this.props.story)}
          {["METERING"].includes(get(this.state, ["access", "grantReason"])) &&
            ((!get(this.state, ["access", "granted"]) && (
              <UtStdLast
                access={this.state.access}
                collectionId={get(this.props, ["issueCollection", "id"])}
                storyUrl={get(this.props, ["story", "url"], null)}
                story={get(this.props, ["story"], null)}
                issueCollection={get(this.props, ["issueCollection"], {})}
                user={true}
                PlansList={get(this.props, ["paywallPlans"], {})}
                razaorpayKey={get(this.props, ["razaorpayKey"], "")}
              />
            )) ||
              (this.state.activeStdPaywall &&
                get(this.state, ["access", "granted"]) &&
                get(this.state, ["access", "remainingStoriesCount"], 0) > 0 && (
                  <UtStdFirst
                    closeThis={() => this.CloseStdPaywall.bind(this)}
                    access={this.state.access}
                    collectionId={get(this.props, ["issueCollection", "id"])}
                    story={get(this.props, ["story"], null)}
                    storyUrl={get(this.props, ["story", "url"], null)}
                    pwtype={get(this.state, ["access", "paywall"], "standard")}
                    count={get(this.state, ["access", "remainingStoriesCount"], 0)}
                  />
                )))}

          {["METERING LOCAL"].includes(get(this.state, ["access", "grantReason"])) &&
            (!get(this.state, ["access", "granted"]) && (
              <UtStdLast
                access={this.state.access}
                collectionId={get(this.props, ["issueCollection", "id"])}
                story={get(this.props, ["story"], null)}
                issueCollection={get(this.props, ["issueCollection"], {})}
                storyUrl={get(this.props, ["story", "url"], null)}
                user={false}
              />
            ))}
          <div className={styles["footer-social-share"]}>{renderSocialMedia()}</div>
          {!isOpen && renderAuthorDetails()}
          {!isOpen && renderTags()}
          <div className={styles["space-before-next-story"]} />
        </div>
      );
    };

    const renderPremiumCard = () => {
      return <React.Fragment>{isPremium(this.props.story) && <StoryPremiumCard />}</React.Fragment>;
    };

    const renderSocialMediaForMobile = props => {
      return (
        <React.Fragment>
          <div className={"show-mobile-and-tablet"}>
            <div className="mobile-view-socialmedia">
              <ul className="show-media-link">
                <li className="share whatsapp">{renderSocialMedia()}</li>
                <li className="share" onClick={() => this.setState({ socialView: !this.state.socialView })}>
                  <a
                    href="JavaScript:"
                    className="styles-m__social-share__link__vv6Ri styles-m__social-share__whatsapp-icon__-G7Vp"
                  >
                    {!this.state.socialView ? <Icon type="socialshare" /> : <Icon type="cancel" />}
                  </a>
                </li>
                <li className="newsletter" onClick={() => props.commentTriggerEvent()}>
                  <a
                    href="javascript:"
                    onClick={this.handleClickEvents.bind(this, "comments")}
                    className="styles-m__social-share__link__vv6Ri styles-m__social-share__whatsapp-icon__-G7Vp"
                  >
                    <Icon type="newsletter" />
                  </a>
                  <VuukleCommentCount mobileView={true} storyId={get(this.props, ["story", "id"], 0)} />
                </li>
              </ul>
            </div>
            {this.state.socialView && renderSocialMedia("show-mobile-and-tablet story-section")}
          </div>
        </React.Fragment>
      );
    };

    const renderProps = {
      renderSocialMedia,
      renderTags,
      renderAuthorDetails,
      renderHeaderCard,
      renderTextStoryHeaderCard,
      renderFooter,
      renderSocialMediaForMobile,
      renderPremiumCard,
      renderSecondaryCard
    };

    const StoryTemplateComponent = getStoryTemplateComponent(story["story-template"]);

    return (
      <StoryTemplateComponent
        story={{
          ...story,
          cards: isPremium(story)
            ? isPremium(story) && (!get(this.state, ["access", "granted"], true) ? [] : story.cards)
            : !isPremium(story) &&
              this.state.show_rfm &&
              this.props.story["story-template"] === "text" &&
              (this.state.RFM_SEGMENT === "Active1" ||
                this.state.RFM_SEGMENT === "Potential1" ||
                this.state.RFM_SEGMENT === "Loyalists1")
              ? []
              : story.cards
        }}
        config={config}
        episodes={episodes}
        {...renderProps}
        fireVirtualPageView={this.props.firePageView}
        READMORE_ENABLE={this.props.READMORE_ENABLE}
        relatedStories={this.state.relatedStories}
        checkInfoStatus={this.props.checkInfoStatus}
        versionStat={versionStat}
        handleExpandStory={this.handleExpandStory}
        index={this.props.index}
        glance={true}
      />
    );
  }
}

export class StoryGlacePageBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      story,
      fetchSectionStories,
      episodes,
      config,
      metypeConfig,
      firePageView,
      issueCollection,
      READMORE_ENABLE,
      index,
      checkInfoStatus,
      versionStat,
      actionhandleActivePaywall,
      activePaywall,
      activeStdPaywall,
      actionhandleStdActivePaywall,
      latestStories,
      trendingStories,
      paywallPlans,
      razaorpayKey
    } = this.props;

    let readmoreStat = READMORE_ENABLE;
    return (
      <div className={`js-content-insights-${story.id}`}>
        <StoryTemplate
          story={story}
          config={config}
          fetchSectionStories={fetchSectionStories}
          episodes={episodes}
          metypeConfig={metypeConfig}
          paywallPlans={paywallPlans}
          razaorpayKey={razaorpayKey}
          firePageView={firePageView}
          issueCollection={issueCollection}
          READMORE_ENABLE={readmoreStat}
          checkInfoStatus={checkInfoStatus}
          versionStat={versionStat}
          index={index}
          actionhandleActivePaywall={actionhandleActivePaywall}
          activePaywall={activePaywall}
          actionhandleStdActivePaywall={actionhandleStdActivePaywall}
          activeStdPaywall={activeStdPaywall}
          latestStories={latestStories}
          trendingStories={trendingStories}
        />
      </div>
    );
  }
}
StoryGlacePageBase.propTypes = {
  episodes: StoryHeader.propTypes.episodes,
  story: TextStory.propTypes.story,
  config: PropTypes.object,
  metypeConfig: PropTypes.object,
  recentStory: PropTypes.object,
  paywallPlans: PropTypes.object,
  razaorpayKey: PropTypes.object,

  fetchSectionStories: PropTypes.func,
  firePageView: PropTypes.func,
  issueCollection: PropTypes.shape({
    id: PropTypes.number
  }),
  READMORE_ENABLE: PropTypes.bool,
  index: PropTypes.number,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  userType: PropTypes.string,
  actionhandleActivePaywall: PropTypes.func,
  activePaywall: PropTypes.bool,
  visualStories: PropTypes.shape(),
  actionhandleStdActivePaywall: PropTypes.func,
  activeStdPaywall: PropTypes.bool,
  latestStories: PropTypes.shape(),
  trendingStories: PropTypes.shape()
};

class WrapperStoryIntersectionObserverBase extends React.Component {
  constructor(props) {
    super(props);
    this.storyRef = React.createRef();
  }

  componentDidMount() {
    this.intersectionObserver =
      global.IntersectionObserver &&
      new global.IntersectionObserver(
        entries => {
          // There will be only One target as we are implementing one Intersection Observer for every Story
          if (entries[0].isIntersecting === true) {
            this.intersectionObserver && this.intersectionObserver.disconnect();
          }
        },
        {
          rootMargin: "0px"
        }
      );
    /* eslint-disable react/no-find-dom-node */
    this.intersectionObserver.observe(ReactDOM.findDOMNode(this.storyRef.current));
  }
  componentWillUnmount() {
    this.intersectionObserver && this.intersectionObserver.disconnect();
  }
  render() {
    return <StoryGlacePageBase {...this.props} ref={this.storyRef} />;
  }
}
// Dispatch the action to update the store from the Intersection Observer
const mapDispatchToProps = dispatch => {
  return {
    updateRemainingStoriesCounter: function(remainingStoriesCount) {
      dispatch({
        type: "UPDATE_STORIES_READ_STATS",
        remainingStoriesCount: remainingStoriesCount
      });
    }
  };
};
const WrapperStoryIntersectionObserver = connect(
  state => state,
  mapDispatchToProps
)(WrapperStoryIntersectionObserverBase);

const getStoriesByLabel = collection => {
  return collection.items.filter(({ story = {} }) => story.headline && story.url).reduce((storyMap, item) => {
    const label = get(item, ["associated-metadata", "label"], "மற்றவை");
    if (storyMap[label]) {
      storyMap[label].push(item.story);
    } else {
      storyMap[label] = [item.story];
    }
    return storyMap;
  }, {});
};

const generateSecondaryMenu = (issueCollection, magazine) => {
  const storyMap = issueCollection && getStoriesByLabel(issueCollection);
  const rootMenuGroup = Object.keys(storyMap).map((label, idx) => {
    return {
      title: label,
      id: idx,
      items: storyMap[label].map(storyObject => {
        return {
          title: storyObject["headline"],
          url: storyObject["url"]
        };
      })
    };
  });

  const firstElement = magazine.name && (
    <Link href={issueCollection.pagePath} className={styles["magazine-name"]}>
      {magazine.name.replace(/\(\w+\)/, "")}
    </Link>
  );
  const root = {
    items: rootMenuGroup
  };
  return (
    <SecondaryMenu
      menuGroup={root}
      className={styles["magazine-secondary"]}
      firstElement={firstElement}
      communityColor={magazine.color}
    />
  );
};

export class StoryGlancePage extends React.Component {
  constructor(props) {
    super(props);
    this.firePageView = this.firePageView.bind(this);
    this.cachedFirstPageStories = [];
    this.MAX_ALREADY_STORIES_READ_COUNT = 5;
    this.state = {
      READMORE_ENABLE: false,
      visibleStories: [],
      relatedStories: [],
      latestStories: null,
      trendingStories: null,
      userType: "F",
      activePaywall: true,
      activeStdPaywall: true,
      user: null,
      nextStory: [],
      storyUrls: [],
      isVisible: false,
      evList: [],
      sequnce: 0,
      footerSlot: false
    };
    this.checkInfoStatus = this.checkInfoStatus.bind(this);
    this.scrollFunction = this.scrollFunction.bind(this);
  }

  timer = () => {
    this.interval = setInterval(() => {
      global.userPromise.catch(() => null).then(user => {
        let userId = get(user, ["userId"], "");
        if (userId === "826969") {
          this.setState({
            sequnce: this.state.sequnce + 1
          });
          STORY_TRACKING.ping(this.state.sequnce);
        }
      });
    }, 20000);
  };

  isStoryNotReadYet(storyId) {
    if (!global.localStorage) {
      return true;
    }

    const alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    return !alreadyReadStories.includes(storyId);
  }

  markStoryAsRead(storyId) {
    if (!global.localStorage) {
      return null;
    }

    if (isGaa()) {
      return null;
    }

    let alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    if (alreadyReadStories.length >= this.MAX_ALREADY_STORIES_READ_COUNT) {
      alreadyReadStories = [];
    }
    let alreadyReadStoriesSet = new Set(alreadyReadStories);
    alreadyReadStoriesSet.add(storyId);
    global.localStorage.setItem("alreadyReadStories", JSON.stringify(Array.from(alreadyReadStoriesSet)));
    global.localStorage.removeItem("premiumStoriesRead");
  }

  storyPageLoadItems(currentHostUrl, pageNumber, collectionMapping) {
    const current = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(current.getDate() + 28);
    let NUMBER_OF_STORIES_PER_PAGE = 5;

    let limit =
      this.MAX_ALREADY_STORIES_READ_COUNT / NUMBER_OF_STORIES_PER_PAGE > pageNumber + 1
        ? this.MAX_ALREADY_STORIES_READ_COUNT
        : 5;

    let storiesPromise = Promise.resolve(this.cachedFirstPageStories);
    if (
      !this.cachedFirstPageStories.length ||
      this.MAX_ALREADY_STORIES_READ_COUNT / NUMBER_OF_STORIES_PER_PAGE < pageNumber + 1
    ) {
      storiesPromise = fetchCollection("glance-collection", pageNumber, limit, {}).then(response => {
        return this.collectioshema(
          response["items"].map(item => item.story.access !== "subscription" && item).filter(x => x)
        );
      });
    }

    return storiesPromise.then(stories => {
      this.cachedFirstPageStories = stories;
      const storiesAfterFiltering = stories.filter(({ story }) => this.isStoryNotReadYet(story.id));
      if (!storiesAfterFiltering.length) {
        return stories.slice(0, NUMBER_OF_STORIES_PER_PAGE);
      }

      const CurrentStory = get(this.props, ["data", "story"], {});
      const newObj = [...stories];
      pageNumber === 0 && newObj.unshift({ story: CurrentStory });

      newObj.filter(({ story }) => story.id !== CurrentStory.id).map(({ story }, i) => {
        var len = newObj.length;
        var previous = newObj[(i + len - 1) % len];
        var next = newObj[(i + 1) % len];
        let obj = Object.assign(story, { pre: previous, next: next });

        this.setState({
          nextStory: [...this.state.nextStory, obj]
        });

        if (i === 0) {
          this.setState({
            storyUrls: obj
          });
        }
      });

      // if false means Disabled all Read more option
      this.setState({
        READMORE_ENABLE: true
      });

      return storiesAfterFiltering.slice(0, NUMBER_OF_STORIES_PER_PAGE);
    });
  }

  collectioshema = stories => {
    return stories
      ? stories.map(data => ({
          story: appendCustomQueryStringUrl(data.story),
          id: data.id,
          score: data.score,
          type: data.type,
          item: data.item
        }))
      : [];
  };

  whenReady = callback => {
    global &&
      global.SWG &&
      global.SWG.push(subscriptions => {
        callback(subscriptions);
      });
  };

  startFlow = (flow, varArgs) => {
    this.whenReady(subscriptions => {
      const flowFunc = subscriptions[flow];
      const flows = Object.keys(subscriptions);
      if (!(typeof flowFunc === "function")) {
        throw new Error('Flow "' + flow + '" not found: Available flows: "' + flows + '"');
      }
      console.log("starting flow", flow, "(", varArgs, ")", " {" + flows + "}");
      const result = flowFunc.apply(subscriptions, varArgs);
      Promise.resolve(result).then(() => {
        console.log("flow complete", flow);
      });
    });
  };

  componentDidMount() {
    let search = window && window.location && window.location.search;
    let Utm = new URLSearchParams(search);
    let utmsource = Utm.get("utm_medium");

    if (utmsource === "r") {
      this.setState({ footerSlot: "22029514685/Realme/Vikatan_footer_sticky" });
    } else if (utmsource === "x") {
      this.setState({ footerSlot: "22029514685/xiaomi_lp/Vikatan_footer_sticky" });
    } else if (utmsource === "s") {
      this.setState({ footerSlot: "22029514685/samsung/Vikatan_footer_sticky" });
    }
    window.addEventListener("scroll", this.scrollFunction);
    const current = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(current.getDate() + 28);
    const story = get(this.props, ["data", "story"], {});
    const collectionMapping = get(this.props, ["config", "collectionMapping"], null);
    global.localStorage && global.localStorage.setItem("story-view", story.id);
    let hostName = global && global.location && global.location.hostname;
    let curHost = global && global.location && global.location.host;
    let currentDomain = hostName === "localhost" ? get(this.props, ["config", "sketches-host"], null) : curHost;
    this.storyPageLoadItems(currentDomain, 0, collectionMapping);
    this.markStoryAsRead(story.id);
    this.firePageView();

    this.timer();
    global.userPromise.catch(() => null).then(user => {
      let userTypeStat = get(user, ["userType"], "F");
      // const userJoinDateStat = get(user, ["userJoinDate"], "2019-10-08 07:41:05");
      let curUrl = global && global.location && global.location.href;

      this.setState({ userType: userTypeStat, user: user });

      global &&
        global.SWG &&
        global.SWG.push(subscriptions => {
          // isGaa start
          if (isGaa()) {
            // Callbacks.
            this.whenReady(subs => {
              const eventCallback = eventName => {
                return value => {
                  const promise = Promise.resolve(value);
                  promise.then(
                    function(response) {
                      console.log(eventName, response);
                    },
                    function(reason) {
                      console.log(eventName + "failed", reason);
                    }
                  );
                };
              };
              subs.setOnEntitlementsResponse(eventCallback("entitlements"));
              subs.setOnLinkComplete(eventCallback("link-complete"));
              subs.setOnLoginRequest(eventCallback("login-request"));
              subs.setOnSubscribeResponse(eventCallback("subscribe"));
              subs.setOnFlowStarted(eventCallback("flow-started"));
              subs.setOnFlowCanceled(eventCallback("flow-canceled"));
            });

            if (!isPremium(story)) {
              subscriptions.setShowcaseEntitlement({
                entitlement: "EVENT_SHOWCASE_UNLOCKED_FREE_PAGE",
                isUserRegistered: (user && true) || false
              });
            } else if (user) {
              if (userTypeStat === "P") {
                subscriptions.setShowcaseEntitlement({
                  entitlement: "EVENT_SHOWCASE_UNLOCKED_BY_SUBSCRIPTION",
                  isUserRegistered: (user && true) || false
                });
              } else {
                this.whenReady(sub => {
                  // Forget any subscriptions, for metering demo purposes.
                  sub.clear();

                  // Handle clicks on the Metering Toast's "Subscribe" button.
                  sub.setOnNativeSubscribeRequest(() => {
                    // Show a publisher paywall for demo purposes.
                    global.location.href = `https://store.vikatan.com/gns-payment?redirect_url=${encodeURIComponent(
                      curUrl
                    )}`;
                  });

                  // Handle clicks on the "Already have an account?" link within the
                  // Metering Regwall dialog.
                  sub.setOnLoginRequest(() => {
                    if (global)
                      global.location.href = `https://login.vikatan.com?redirect_url=${encodeURIComponent(curUrl)}`;
                  });

                  // Handle users linking their account.
                  sub.setOnLinkComplete(() => {
                    sub.reset();

                    // location.reload();
                  });

                  // Fetch entitlements.
                  sub.getEntitlements().then(entitlements => {
                    if (entitlements.enablesThis()) {
                      // Unlock article right away, since the user has a subscription.
                      MeteringDemo.openPaywall();
                    } else {
                      // Attempt to unlock article with metering.
                      this.maybeUnlockWithMetering(userTypeStat, (user && true) || false);
                    }
                  });
                });
              }
            } else {
              if (userTypeStat !== "P") {
                this.whenReady(sub => {
                  // Forget any subscriptions, for metering demo purposes.
                  sub.clear();

                  // Handle clicks on the Metering Toast's "Subscribe" button.
                  sub.setOnNativeSubscribeRequest(() => {
                    // Show a publisher paywall for demo purposes.
                    global.location.href = `https://store.vikatan.com/?redirect_url=${encodeURIComponent(curUrl)}`;
                  });

                  // Handle clicks on the "Already have an account?" link within the
                  // Metering Regwall dialog.
                  sub.setOnLoginRequest(() => {
                    if (global)
                      global.location.href = `https://login.vikatan.com?redirect_url=${encodeURIComponent(curUrl)}`;
                    console.log("linkAccount))))))))))))))))))))");
                  });

                  // Handle users linking their account.
                  sub.setOnLinkComplete(() => {
                    sub.reset();
                    console.log("setOnLinkComplete))))))))))))))))))))");
                    // location.reload();
                  });

                  // Fetch entitlements.
                  sub.getEntitlements().then(entitlements => {
                    console.log("entitlements))))))))))))))))))))", entitlements);
                    console.log("entitlements.enablesThis()))))))))))))))))))))", entitlements.enablesThis());
                    if (entitlements.enablesThis()) {
                      // Unlock article right away, since the user has a subscription.
                      console.log("openPaywall-----------))))))))))))))))))))");
                      MeteringDemo.openPaywall();
                    } else {
                      // Attempt to unlock article with metering.
                      this.maybeUnlockWithMetering(userTypeStat, (user && true) || false);
                    }
                  });
                });
              }
            }
          }
          // isGaa end
        });
    });

    fetchLatestStories(0, 4)
      .then(relatedStories => {
        this.setState({ relatedStories });
      })
      .catch(console.error);

    fetchSectionStories(story)
      .then(sectionStories => {
        this.setState({ sectionStories });
      })
      .catch(console.error);
    const storyId = get(this.props, ["data", "story", "id"], null);
    if (global && global.matchMedia("(min-width: 768px)").matches) {
      fetchLatestAtVikatan(0, 5, { "exclude-story-ids": storyId })
        .then(response => {
          this.setState({ latestStories: response });
          const story = get(response, ["items"], null);
          let storyIds =
            story && story.length > 0 && story.map(story => story && story !== undefined && story.id).join(",");

          const params = {};
          if (storyIds && storyIds !== undefined) {
            params["exclude-story-ids"] = `${storyId},${storyIds}`;
          }

          fetchTrendingStories(0, 5, params)
            .then(response => {
              this.setState({ trendingStories: response });
            })
            .catch(console.error);
        })
        .catch(console.error);
    }
  }

  maybeUnlockWithMetering = (userTypeStat = "F", user = false) => {
    // Fetch the current user's metering state.
    const curUrl = global && global.location && global.location.href;
    this.whenReady(sub => {
      MeteringDemo.fetchMeteringState()
        .then(meteringState => {
          if (meteringState.registrationTimestamp) {
            // Skip metering regwall for registered users.
            return meteringState;
          }

          // Show metering regwall for unregistered users.
          return (
            global &&
            global.GaaMeteringRegwall.show({
              // Specify a URL that renders a Google Sign-In button.
              iframeUrl: MeteringDemo.GOOGLE_SIGN_IN_IFRAME_URL
            })
              .then(googleSignInUser =>
                // Register a user based on data from Google Sign-In.
                //
                // We advise setting a 1st party, secure, HTTP-only cookie,
                // so it lives past 7 days in Safari.
                // https://webkit.org/blog/10218/full-third-party-cookie-blocking-and-more/

                MeteringDemo.registerUser(googleSignInUser)
              )
              .then(() =>
                // Fetch the current user's metering state again
                // since they registered.
                MeteringDemo.fetchMeteringState()
              )
          );
        })
        .then(meteringState => {
          // Forget previous entitlements fetches.
          sub.clear();

          // Get SwG entitlements.
          return sub.getEntitlements({
            metering: {
              state: {
                // Hashed identifier for a specific user. Hash this value yourself
                // to avoid sending PII.
                id: meteringState.id,
                // Standard attributes which affect your meters.
                // Each attribute has a corresponding timestamp, which
                // allows meters to do things like granting access
                // for up to 30 days after a certain action.
                //
                // TODO: Describe standard attributes, once they're defined.
                standardAttributes: {
                  registered_user: {
                    timestamp: meteringState.registrationTimestamp
                  }
                }
              }
            }
          });
        })
        .catch(() => false)
        .then(entitlements => {
          console.log("entitlements function-----------))))))))))))))))))))", entitlements);
          // Check if a Google metering entitlement unlocks the article.
          if (entitlements && entitlements.enablesThisWithGoogleMetering()) {
            console.log(
              "entitlements.enablesThisWithGoogleMetering() function-----------))))))))))))))))))))",
              entitlements.enablesThisWithGoogleMetering()
            );
            console.log("out entitlements.consume function-----------))))))))))))))))))))", entitlements.consume());
            // Consume the entitlement. This lets Google know a specific free
            // read was "used up", which allows Google to calculate how many
            // free reads are left for a given user.
            //
            // Consuming an entitlement will also trigger a dialog that lets the user
            // know Google provided them with a free read.
            entitlements.consume(() => {
              // Unlock the article AFTER the user consumes a free read.
              // Note: If you unlock the article outside of this callback,
              // users might be able to scroll down and read the article
              // without closing the dialog, and closing the dialog is
              // what actually consumes a free read.
              console.log("entitlements.consume function-----------))))))))))))))))))))", entitlements.consume());
              MeteringDemo.openPaywall();
            });
          } else {
            // Handle failures to unlock the article with metering entitlements.
            // Perhaps the user ran out of free reads. Or perhaps the user
            // dismissed the Regwall. Either way, the publisher determines
            // what happens next. This demo shows offers.
            // this.startFlow("showOffers");
            sub.setShowcaseEntitlement({
              entitlement: "EVENT_SHOWCASE_NO_ENTITLEMENTS_PAYWALL",
              isUserRegistered: (user && true) || false
            });
            if (userTypeStat !== "P") {
              console.log("Entered ===> free", userTypeStat);
              global.location.href = `https://store.vikatan.com/gns-payment?redirect_url=${encodeURIComponent(curUrl)}`;
            } else {
              console.log("Entered paid", userTypeStat);
            }
            // global && global.location.reload();
          }
        });
    });
  };

  firePageView(story = this.props.data.story, firedFromInfinite = false) {
    if (this.props.config.disableAds) {
      return;
    }
    const issueCollection = get(this.props, ["data", "issueCollection"], null);
    const magazineEntity = get(this.props, ["data", "magazineEntity"], null);
    currentStory.setStorydata(story, issueCollection);

    EVOLOK.loadScript(this.props.pageType, {
      story: story,
      collection: { ...issueCollection, magazineEntity: magazineEntity }
    });

    fetchStoryAttributes(story)
      .then(result => {
        GA.registerPageView(this.props.pageType, {
          story: { ...story, collections: result.collections },
          collection: issueCollection,
          infiniteTagRequired: firedFromInfinite
        });
        DeepBI.registerPageView({ story: { ...story, collections: result.collections }, glance: true });
      })
      .catch(console.error);
  }

  checkInfoStatus = stat => {
    const story = get(this.props, ["data", "story"]);
    this.setState({
      sequnce: 0
    });
    if (stat.status === true) {
      this.sendQlitics(story);
      this.setState({
        visibleStories: [...this.state.visibleStories, stat.id]
      });
    } else {
      let filteredArray = this.state.visibleStories.filter(item => item !== stat.id);
      this.setState({
        visibleStories: filteredArray
      });
    }
  };

  sendQlitics = (story = {}) => {
    const { registerStoryView } = require("@quintype/framework/client/analytics");
    registerStoryView(story.id);
  };

  handleActivePaywall = args => {
    this.setState({
      activePaywall: args
    });
  };

  handleSetStoryUrls = args => {
    this.setState({
      storyUrls: args
    });
  };

  handleStdActivePaywall = args => {
    this.setState({
      activeStdPaywall: args
    });
  };

  // Define function to send userState to Google using subscriptions object
  checkShowcaseEntitlement = userState => {
    let email = get(userState, ["email"], "");
    let auth = get(userState, ["authorizationData", "access_token"], "");
    if (userState) {
      // Send userState to Google
      reqSwgUser(email, auth).then(res => {
        console.log("checkShowcaseEntitlement ", res);
        const logInCookie = get(res, ["cookies"], []);
        logInCookie.map(item => {
          console.log("logInCookie item====", item);
          cookies.set(item.key, item.value, { path: "/", domain: ".vikatan.com" });
        });
      });
      console.log("userState in====", userState);
    } else {
      // If userState is undefined, it’s likely the user isn’t logged in.
      // Do not send an empty userState to Google in this case.
      this.showGoogleRegwall();
    }
  };

  showGoogleRegwall = () => {
    console.log("showGoogleRegwall");
    global &&
      global.GaaMeteringRegwall &&
      global.GaaMeteringRegwall.show({
        // Specify a URL that renders a Google Sign-In button.
        // See the Google Sign-In widget section.
        iframeUrl: "https://www.vikatan.com/registration_widget"
      }).then(googleSignInDetails => {
        this.checkShowcaseEntitlement(googleSignInDetails);
        console.log("googleSignInDetails", googleSignInDetails);
      });
  };

  scrollFunction() {
    if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
      this.setState({ isVisible: true });
    } else {
      this.setState({ isVisible: false });
    }
  }

  render() {
    const metypeConfig = get(this.props, ["data", "publisherConfig", "metypeConfig"]);
    const paywallPlans = get(this.props, ["data", "publisherConfig", "paywallPlans"]);
    const razaorpayKey = get(this.props, ["data", "publisherConfig", "razarpayKey"]);
    const collectionMapping = get(this.props, ["config", "collectionMapping"], null);
    const issueCollection = get(this.props, ["data", "issueCollection"]);
    const magazineEntity = get(this.props, ["data", "magazineEntity"]);
    const cinemaMode = get(this.props, ["config", "cinemaMode"]);
    const { userType, nextStory, footerSlot } = this.state;
    const storyId = get(this.props, ["data", "story", "id"], {});

    return (
      <React.Fragment>
        <div className={`${styles["outer-engagement-bar"]}`}>
          <div className={`${styles["footer-ad-slot"]}`}>
            {footerSlot && (
              <WithLazy>
                {() => (
                  <CustomAdslot
                    path={footerSlot && footerSlot}
                    size={[[320, 50], [300, 50]]}
                    id={`div-gpt-ad-1-${storyId}`}
                  />
                )}
              </WithLazy>
            )}
          </div>
          <div className={`${styles["bottom-grid"]}`}>
            <a
              href="https://www.vikatan.com/latest-news?pfrom=glance-story"
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["LatestAmp"]}`}
            >
              <span className={`${styles["bottom-icon"]}`}>
                <LatestAMP width={20} height={20} />
              </span>
              <span>Latest</span>
            </a>
            <a
              href="https://www.vikatan.com/collection/trending-at-vikatan?pfrom=glance-story"
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["TrendingAmp"]}`}
            >
              <span className={`${styles["bottom-icon"]}`}>
                <TrendingAMP width={20} height={20} />
              </span>
              <span>Trending</span>
            </a>
            <a
              href="https://www.vikatan.com/magazine-list?pfrom=glance-story"
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["MagazineAmp"]}`}
            >
              <span className={`${styles["bottom-icon"]}`}>
                {" "}
                <MagazineAmp width={20} height={20} />
              </span>
              <span>Magazines</span>
            </a>
            <a href="https://vikatanmobile.page.link/glance_footer" className={`${styles["InstallAmp"]}`}>
              <span className={`${styles["bottom-icon"]}`}>
                <AppInstallAmp width={20} height={20} />
              </span>
              <span>Install App</span>
            </a>
          </div>
        </div>

        {issueCollection &&
          magazineEntity && (
            <div className={styles["secondary-menu"]}>{generateSecondaryMenu(issueCollection, magazineEntity)}</div>
          )}

        <div className={`main-page ${styles["base"]} ${styles["glance-main-wrapper"]} js-story-main-container`}>
          <div />
          <WithHostUrl>
            {({ currentHostUrl }) => (
              <InfiniteStoryBase
                {...this.props}
                render={storyProps => (
                  <WrapperStoryIntersectionObserver
                    {...Object.assign({}, storyProps)}
                    config={this.props.config}
                    metypeConfig={metypeConfig}
                    fetchSectionStories={story => storyPageFetchRelatedItems(currentHostUrl, story, cinemaMode)}
                    firePageView={() => this.firePageView(storyProps.story)}
                    READMORE_ENABLE={this.state.READMORE_ENABLE}
                    checkInfoStatus={this.checkInfoStatus}
                    versionStat={this.props.versionStat}
                    activePaywall={this.state.activePaywall}
                    actionhandleActivePaywall={this.handleActivePaywall}
                    activeStdPaywall={this.state.activeStdPaywall}
                    actionhandleStdActivePaywall={this.handleStdActivePaywall}
                    userType={userType}
                    latestStories={this.state.latestStories}
                    trendingStories={this.state.trendingStories}
                    paywallPlans={paywallPlans}
                    razaorpayKey={razaorpayKey}
                  />
                )}
                loadItems={pageNumber => this.storyPageLoadItems(currentHostUrl, pageNumber, collectionMapping)}
                onInitialItemFocus={(item, key) => {
                  if (item.story && item.story.id) {
                    this.markStoryAsRead(item.story.id);
                    if (key === "1") {
                      this.firePageView(item.story, true);
                    }
                  }
                }}
                onItemFocus={(item, key) => {
                  this.handleActivePaywall(this.state.activePaywall);
                  // const stortId = get(item, ["story", "id"]);
                  // const versionStat = get(item, ["story", "pfrom"], null);
                  // const storyUrlView = visibleStories.indexOf(stortId);

                  nextStory.length >= 0 && this.handleSetStoryUrls(nextStory[key]);

                  // if (storyUrlView !== -1) {
                  //   this.setState({
                  //     sequnce: 0
                  //   });
                  //   global.app.maybeSetUrl(
                  //     "/" + item.story.slug + "?pfrom=" + versionStat,
                  //     get(item, ["story", "seo", "meta-title"], item.story.headline)
                  //   );
                  // } else if (key === "0") {
                  //   this.setState({
                  //     sequnce: 0
                  //   });
                  //   global.app.maybeSetUrl(
                  //     "/" + item.story.slug,
                  //     get(item, ["story", "seo", "meta-title"], item.story.headline)
                  //   );
                  // } else {
                  //   this.setState({
                  //     sequnce: 0
                  //   });
                  //   global.app.maybeSetUrl("/story-feed", "Vikatan Feed", "Vikatan Feed");
                  // }
                }}
                neverHideItem={true}
                doNotChangeUrl={true}
              />
            )}
          </WithHostUrl>
          <div />
        </div>
        <React.Fragment />
      </React.Fragment>
    );
  }
}
